import { LINK_ICON_POSITIONS } from 'cdk-radial';
import { UseQueryResult } from 'react-query';
import { LinkRenderer } from 'components';
import { LinkIconPositions } from 'components/LinkRenderer/types';
import { PDFGenerationBase64Type } from 'hooks/types';
import { useFetchBase64 } from 'hooks/useClientDataServices';
import { ReconciliationReportDataType } from 'pages/ReconciliationReportPage/types';

export const RemittanceFormRenderer = ({
  data: { documentId },
  isRCC
}: {
  data: ReconciliationReportDataType;
  isRCC: boolean;
}): React.JSX.Element => {
  const { refetch }: UseQueryResult<PDFGenerationBase64Type, Error> =
    useFetchBase64(documentId, isRCC);
  const handleRemittanceFormLink = () => refetch();
  return (
    <>
      {documentId && (
        <LinkRenderer
          linkText={documentId}
          linkIconPosition={(LINK_ICON_POSITIONS as LinkIconPositions).TRAILING}
          handleClick={handleRemittanceFormLink}
        />
      )}
    </>
  );
};
